const { EUROPEAN_COUNTRIES_CODES } = require('../../../shared/constants.js')

const isEuropeanCountry = country => Boolean(country) && EUROPEAN_COUNTRIES_CODES.includes(country)

module.exports = isEuropeanCountry
